// require all files in dir
const context = require.context('./', true, /\.(js|coffee)$/)
context.keys().forEach(context)
